import type { DriverTeamChannelEntity } from './DriverTeamChannelEntity'

export class DriverTeamMiniEntity {
  id?: number
  name?: string | null
  numberOfDrivers?: number
  channels?: Array<DriverTeamChannelEntity> | null
}
